import React from "react";

export default function Li(props) {
  return (
    <>
      <li className="px-2">{props.data}</li>
    </>
  );
}
